import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

const currentDate = new Date();

const ActionRenderer = (props) => {
  return (
    <div className="flex item-center">
      <Button color="warning" variant="contained" sx={{ mr: 1 }}>
        Pay
      </Button>
      <Button color="warning" variant="contained">
        {" "}
        View
      </Button>
    </div>
  );
};

export default function CompanyPaidAllowance(props) {
  const navigate = useNavigate();

  const classes = useStyles(props);
  const { generatePayroll } = props;

  const [payGroupOptions, setPayGroupOptions] = useState([
    { label: "All", value: "All" },
    { label: "Nolte FZE", value: "Nolte FZE" },
    { label: "Free Lance", value: "Free Lance" },
    { label: "IT Consulant", value: "IT Consulant" },
  ]);

  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);

  const gridRef = useRef();

  const [totalClaimed, setTotalClaimed] = useState();
  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const [tabValue, setTabValue] = useState("nolte");

  const [columnDefs, setColumnDefs] = useState([
    { field: "code", headerName: "Code" },
    { field: "employeeName", headerName: "Employee Name" },
    { field: "visaExpenses", headerName: "Visa Expenses" },
    { field: "medicalInsurance", headerName: "Medical Insurance" },
    { field: "Gratuity", headerName: "Gratuity" },
    { field: "travelVisa", headerName: "Travel Visa" },
    { field: "airTravel", headerName: "Air Travel" },
    { field: "insuranceExpense", headerName: "Insurance Expense" },
    { field: "hotel", headerName: "Hotel" },
    { field: "dailyAllowance", headerName: "Daily Allowance" },
    { field: "clientWelfare", headerName: "Client Welfare" },
    { field: "rentCar", headerName: "Rent A Car" },
    { field: "petrolCharges", headerName: "Petrol / Taxi Charges" },
    { field: "refreshmentExp", headerName: "Refreshment Exp" },
    { field: "totalIndirectPayments", headerName: "Total Indirect Payments" },
  ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "View",
        icon: '<span><i class="material-icons style="font-size: 18px">visibility</i></span>',
        action: () => {
          // onBtEdit(event);
        },
      },
      {
        name: "Pay",
        icon: '<span><i class="material-icons" style="font-size: 18px">paid</i></span>',
        action: () => {
          // onBtDeleteRow(event);
        },
      },
    ];
    return result;
  }, []);

  const handleTabChange = (event, value) => setTabValue(value);

  return (
    <>
      <FormPageHeader
        componentName="Employee Cost"
        pageName={"Employee Cost"}
        currentPage={"Employee Cost"}
      />

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="pb-6 items-center">
          <Grid xs={16} item>
            <Stack direction="row" spacing={2}>
              <Stack>
                Emplyee Name
                <TextField
                  className="mb-4 w-[100px]"
                  type="text"
                  variant="outlined"
                  fullWidth
                />
              </Stack>
              <Stack>
                <label>Period From</label>
                <Stack direction="row">
                  <TextField
                    className="mb-4 w-[50px]"
                    type="text"
                    required
                    variant="outlined"
                    fullWidth
                    sx={{ mr: 2 }}
                  />
                  <TextField
                    className="mb-4 w-[100px]"
                    type="text"
                    variant="outlined"
                    fullWidth
                  />
                </Stack>
              </Stack>
              <Stack>
                <label>Period To</label>
                <Stack direction="row">
                  <TextField
                    className="mb-4 w-[50px]"
                    type="text"
                    required
                    variant="outlined"
                    fullWidth
                    sx={{ mr: 2 }}
                  />
                  <TextField
                    className="mb-4 w-[100px]"
                    type="text"
                    variant="outlined"
                    fullWidth
                  />
                </Stack>
              </Stack>
              <div className="mt-16 flex items-end">
                <Button
                  color="warning"
                  variant="contained"
                  startIcon={
                    <FuseSvgIcon size={18}>
                      heroicons-outline:search
                    </FuseSvgIcon>
                  }
                  sx={{ mr: 1 }}
                />
              </div>
            </Stack>
          </Grid>
        </Grid>
      </div>

      <div className="h-full">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab 
            label="NOLTE FZE (2)" 
            value={"nolte"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="FREE LANCE (0)" 
            value={"free-lance"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="IT CONSULTANT (18)" 
            value={"it-consultant"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
        </Tabs>

        <AgGridTable
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowGroupPanelShow="never"
          getContextMenuItems={getContextMenuItems}
        />
      </div>
    </>
  );
}
